import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'text' | 'white'; // 'white' varyantı eklendi (koyu zeminler için)
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean; // Butonun tam genişlik olup olmayacağı
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  type = 'button',
  disabled = false,
  icon,
  iconPosition = 'left',
  fullWidth = false,
}) => {
  
  // Temel stiller: Yuvarlak hatlar, yumuşak geçişler, tıklama efekti
  const baseStyles = `
    inline-flex items-center justify-center 
    font-medium tracking-wide 
    rounded-full 
    transition-all duration-300 ease-out 
    focus:outline-none focus:ring-2 focus:ring-offset-2 
    active:scale-95 
    disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-none
  `;
  
  const variantStyles = {
    // Koyu Lacivert/Mor Buton (Ana aksiyonlar için)
    primary: `
      bg-primary-900 text-white 
      hover:bg-primary-800 
      shadow-lg shadow-primary-900/20 hover:shadow-primary-900/40 
      hover:-translate-y-0.5 
      focus:ring-primary-500
    `,
    // Altın Sarısı Buton (Vurgulu aksiyonlar, örn: İndir, Başla)
    secondary: `
      bg-secondary-500 text-white 
      hover:bg-secondary-400 
      shadow-lg shadow-secondary-500/20 hover:shadow-secondary-500/40 
      hover:-translate-y-0.5 
      focus:ring-secondary-500
    `,
    // Çerçeveli Buton (İkincil aksiyonlar)
    outline: `
      border-2 border-primary-900 text-primary-900 bg-transparent
      hover:bg-primary-50 
      focus:ring-primary-500
    `,
    // Sadece Metin
    text: `
      text-primary-700 hover:text-primary-900 
      hover:bg-primary-50/50 
      focus:ring-primary-500 
      !shadow-none !transform-none
    `,
    // Beyaz Buton (Koyu arka planlar veya resimler üzerinde kullanım için)
    white: `
      bg-white text-primary-900 
      hover:bg-gray-50 
      shadow-lg hover:shadow-xl 
      hover:-translate-y-0.5 
      focus:ring-white/50
    `
  };
  
  const sizeStyles = {
    sm: "text-xs px-4 py-2",
    md: "text-sm px-6 py-3",
    lg: "text-base px-8 py-4",
  };
  
  const widthStyles = fullWidth ? "w-full" : "";
  
  return (
    <button
      type={type}
      className={`
        ${baseStyles} 
        ${variantStyles[variant]} 
        ${sizeStyles[size]} 
        ${widthStyles} 
        ${className}
      `}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === 'left' && (
        <span className={`${children ? 'mr-2' : ''} transition-transform group-hover:scale-110`}>
          {icon}
        </span>
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <span className={`${children ? 'ml-2' : ''} transition-transform group-hover:translate-x-1`}>
          {icon}
        </span>
      )}
    </button>
  );
};

export default Button;